export const BRAND = {
  "clientId": "creditosJR",
  "displayName": "créditosJR",
  "legalName": "créditosJR",
  "web": {
    "appTitle": "créditosJR",
    "loginTitle": "Login",
    "apiBaseUrl": "https://api.juego5.creditosjr.misrutas.info/api",
    "publicUrl": "https://juego5.creditosjr.misrutas.info",
    "primaryColor": "#14532D",
    "secondaryColor": "#0F172A",
    "accentColor": "#F59E0B",
    "supportEmail": "soporte@misrutas.info",
    "hideForbiddenActions": true,
    "showMenuIcons": false,
    "assetUrls": {
      "logoFull": "/brand/logo-full.png",
      "logoMark": "/brand/logo-mark.png",
      "favicon": "/favicon.ico",
      "appleTouchIcon": "",
      "ogImage": ""
    }
  }
} as const;
